import { useNavigate } from 'react-router-dom';
import { CalendarCheck2, ChevronRight } from 'lucide-react';
import StudyPlanner from '@/components/premium/StudyPlanner';

/** The student-facing Study / Exam Planner. Read, tick and adjust — the plan is
 * only rebuilt or reset from the Exams page, so nothing is lost by accident. */
export default function PlannerPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-full bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6" data-testid="planner-page">
        <p className="text-[10px] font-heading uppercase tracking-widest text-indigo-500 flex items-center gap-1.5">
          <CalendarCheck2 className="w-3 h-3" /> Study / Exam Planner
        </p>
        <StudyPlanner canManage={false} />
        <button onClick={() => navigate('/exams')} data-testid="planner-go-to-exams"
          className="mt-6 inline-flex items-center gap-1 font-heading text-[12px] text-slate-500 hover:text-slate-800">
          Change the exam, portion or rebuild the plan in the Exam section <ChevronRight className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
}
